import {pageInfo, initUpdate, editData, addData, toxinDetail, exportData, closePlan} from "../api";
import { plant ,goodsCategory, storageList, selectReshipLoadingType, businessType} from '../../../../../api'
const coalPlan = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    initUpdateObj: null,
    updateResp: null,
    addSubmitResp:null,
    plantCodeObj: null,
    goodesCategoryCodeObj: null,
    storageCodeObj: null,
    loadingTypeCodeDataObj: null,
    toxinObj: null,
    businessTypeObj: null,
    exportObj: null,
    closePlanObj: null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj.map(item=>({...item, btns:[{disabled: item.planStatusCode !='normal' ? true : false}, {disabled: item.planStatusCode !='normal' ? true : false}]})) || [];
    },
    UPDATE_INIT_DATA(state, data){
      state.initUpdateObj = data.obj;
    },
    UPDATE_DATA(state, data){
      state.updateResp = data;
    },
    ADD_DATA(state, data){
      state.addSubmitResp = data;
    },
    GOODS_CATEGORY(state, data){
      state.goodsCategoryObj = data.obj || [];
    },
    PURCH_ORDER_PAGEINFO(state, data){
      state.purchOrderTotal = data.total;
      state.purchOrderResp = data.obj || [];
    },
    PLANT_CODE_DATA(state, data){
      state.plantCodeObj = data;
    },
    GOODS_CATEGORY_CODE_DATA(state, data){
      state.goodesCategoryCodeObj = data;
    },
    STORAGE_CODE_DATA(state, data){
      state.storageCodeObj = data;
    },
    LOADING_TYPE_CODE_DATA(state, data){
      state.loadingTypeCodeDataObj = data;
    },
    TOXIN_DATA(state, data){
      state.toxinObj = data;
    },
    BUSINESS_TYPE_DATA(state, data){
      state.businessTypeObj = data;
    },
    EXPORT_DATA(state, data){
      state.exportObj = data;
    },
    CLOSE_PLAN_DATA(state, data){
      state.closePlanObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //修改初始化
    async initUpdate({ commit }, obj) {
      let resp = await initUpdate(obj);
      commit('UPDATE_INIT_DATA', resp);
    },
    //编辑提交
    async editData({ commit }, obj) {
      let resp = await editData(obj);
      commit('UPDATE_DATA', resp);
    },
    //新增提交
    async addSubmit({ commit }, obj) {
      let resp = await addData(obj);
      commit('ADD_DATA', resp);
    },
    //基地
    async getPlantCodeList({ commit }, obj) {
      let resp = await plant(obj);
      commit('PLANT_CODE_DATA', resp);
    },
    //货物类型
    async getGoodsCategoryCodeList({ commit }, obj) {
      let resp = await goodsCategory(obj);
      commit('GOODS_CATEGORY_CODE_DATA', resp);
    },
    //发出库位
    async getStorageCodeList({ commit }, obj) {
      let resp = await storageList(obj);
      commit('STORAGE_CODE_DATA', resp);
    },
    //装货类型
    async getLoadingTypeCodeList({ commit }, obj) {
      let resp = await selectReshipLoadingType(obj);
      commit('LOADING_TYPE_CODE_DATA', resp);
    },
    //业务类型
    async getBusinessTypeList({ commit }, obj) {
      let resp = await businessType(obj);
      commit('BUSINESS_TYPE_DATA', resp);
    },
    //毒素检测项
    async getToxin({ commit }, obj) {
      let resp = await toxinDetail(obj);
      commit('TOXIN_DATA', resp);
    },
    //导出
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async closePlan({ commit }, obj) {
      let resp = await closePlan(obj);
      commit('CLOSE_PLAN_DATA', resp);
    },
  }
}
export default coalPlan



// WEBPACK FOOTER //
// ./src/page/bd/corn/reshipCornPlan/store/reshipCornPlan.store.js